import React, { useEffect } from 'react';
import { get } from 'lodash';
import { Modal, ModalHeader, ModalBody } from '../components/modal/Modal';
import { withModelInfo } from '../common/ModelInfoContext';
import { useNavigate } from 'react-router-dom';

const AdChoices = (props) => {
  const { modelInfo } = props;
  const navigate = useNavigate();

  const onClose = () => {
    navigate('../');
  };

  useEffect(() => {
    const receiveMessage = (event) => {
      if (get(event, 'data') === 'close') {
        props.onClose();
      }
    };

    window.addEventListener('message', receiveMessage, false);

    return () => {
      window.removeEventListener('message', receiveMessage, false);
    };
  }, []);

  return (
    <Modal fullscreen={false} isOpen={true} onRequestClose={onClose}>
      <ModalHeader onClose={onClose} />
      <ModalBody>
        <iframe
          src={modelInfo.adChoicesUrl}
          className="modal-body__content"
          style={{
            width: '100%',
            height: '450px',
          }}
        />
      </ModalBody>
    </Modal>
  );
};

export default withModelInfo(AdChoices);
